export const CarEvaluation = '/requests/car-evaluation'